import { render, staticRenderFns } from "./colorheader.vue?vue&type=template&id=457ad860&scoped=true&"
import script from "./colorheader.vue?vue&type=script&lang=js&"
export * from "./colorheader.vue?vue&type=script&lang=js&"
import style0 from "./colorheader.vue?vue&type=style&index=0&id=457ad860&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ad860",
  null
  
)

export default component.exports